import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { CssButton, CssIcon } from "styles/helpers/layout";

export const StyledTheoryButton = styled(CssButton)`
  padding: 0.25rem 0.75rem;

  .content {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
`;

export const StyledTheoryContainer = styled.div`
  position: relative;
`;

interface StyledTheoryListProps extends ThemeProps {
  $isHidden: boolean;
}

export const StyledTheoryList = styled.ol<StyledTheoryListProps>`
  display: ${(props: StyledTheoryListProps) => (props.$isHidden ? "none" : "block")};

  position: absolute;
  right: 0;
  top: 2.15rem;
  width: 15rem;
  padding: 1rem;
  margin: 0;
  background: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  border: solid 1px ${(props: ThemeProps) => props.theme.palette.neutral._900};
  border-radius: 0.5rem;

  li {
    margin-left: 1.5rem;

    > * {
      width: 100%;
      justify-content: flex-start;
    }

    :not(:first-child) {
      margin-top: 1rem;
    }
  }
`;

export const StyledArrowIcon = styled(CssIcon)`
  display: block;
  border-left: ${(props: ThemeProps) => props.theme.palette.neutral._900} solid 1px;
  padding: 0.25rem 0 0.25rem 0.5rem;
`;
